<template>
<div class="pop-mess">
    <p>{{popMessText}}</p>
</div>
</template>

<script>
export default {
  name: 'PopMess',
  props: [
    "popMessText"
  ],
}
</script>
<style lang="scss" scoped>
// @import "../scss/_variables.scss";
.pop-mess {
    position: fixed;
    bottom: 0;
    background-color: $icon-hover-color;
    width: 100%;
    height: $nav-height;
    z-index: 40;
    display: flex;
    justify-content: center;
    align-items: center;
    p {
        color: $black;
    }
}
</style>
